// extracted by mini-css-extract-plugin
module.exports = {"container":"page_container__cTDGS"};